export default __webpack_public_path__ + "a69ae92ff7143faa6bec54018adef8d5.svg";